var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initLineItemCard = /* @__PURE__ */ __name(($el, lineItemKey) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E;
  const random_id = utils.shortUUID();
  const cart = Alpine.store("cart");
  const applyBundleParentDisplay = /* @__PURE__ */ __name((item) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    if (!((_a2 = item == null ? void 0 : item.item_components) == null ? void 0 : _a2.length)) return item;
    const components = (_d2 = (_c2 = (_b2 = window._cart) == null ? void 0 : _b2.getBundleComponents) == null ? void 0 : _c2.call(_b2, item)) != null ? _d2 : [];
    const first = components[0];
    if (!first) return item;
    let original = 0;
    for (const component of components) {
      const product2 = _products[component == null ? void 0 : component.handle];
      const variant2 = (_e2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _e2.find((v) => v.id === (component == null ? void 0 : component.variant_id));
      if (typeof (variant2 == null ? void 0 : variant2.price) !== "number") {
        original = 0;
        _product.getProductData(component == null ? void 0 : component.handle, component == null ? void 0 : component.product_id).then(() => {
          var _a3;
          if (((_a3 = state == null ? void 0 : state.line_item) == null ? void 0 : _a3.key) === item.key) {
            state.line_item = applyBundleParentDisplay(item);
          }
        });
        break;
      }
      original += variant2.price * ((_f2 = component.quantity) != null ? _f2 : 1);
    }
    const compare_at = original > item.final_line_price ? original : item.original_line_price;
    return {
      ...item,
      image: (_g2 = first.image) != null ? _g2 : item.image,
      featured_image: (_h2 = first.featured_image) != null ? _h2 : item.featured_image,
      handle: (_i2 = first.handle) != null ? _i2 : item.handle,
      product_id: (_j2 = first.product_id) != null ? _j2 : item.product_id,
      variant_id: (_k2 = first.variant_id) != null ? _k2 : item.variant_id,
      title: (_l2 = first.title) != null ? _l2 : item.title,
      product_title: (_m2 = first.product_title) != null ? _m2 : item.product_title,
      variant_title: (_n2 = first.variant_title) != null ? _n2 : item.variant_title,
      options_with_values: (_o2 = first.options_with_values) != null ? _o2 : item.options_with_values,
      original_line_price: compare_at,
      original_price: compare_at
    };
  }, "applyBundleParentDisplay");
  let lineItem = Shopify.designMode ? (_c = (_b = (_a = cart.state.items.find((item) => item.key === lineItemKey)) != null ? _a : cart.state.items.find((item) => {
    var _a2;
    return !!((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._p_id);
  })) != null ? _b : cart.state.items.find((item) => {
    var _a2;
    return !((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._p_id_link);
  })) != null ? _c : cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
  if (!lineItem) {
    for (const item of (_d = cart.state.items) != null ? _d : []) {
      const components = (_f = (_e = item.item_components) == null ? void 0 : _e.map((component) => ({ ...component, item_components: [] }))) != null ? _f : [];
      lineItem = components.find((component) => component.key === lineItemKey);
      if (lineItem) break;
    }
  }
  lineItem = applyBundleParentDisplay(lineItem);
  const children = ((_g = lineItem == null ? void 0 : lineItem.properties) == null ? void 0 : _g._p_id) ? (_h = cart.state.items.filter((child) => {
    var _a2, _b2;
    return ((_a2 = child == null ? void 0 : child.properties) == null ? void 0 : _a2._p_id_link) === ((_b2 = lineItem == null ? void 0 : lineItem.properties) == null ? void 0 : _b2._p_id) && child.quantity;
  })) == null ? void 0 : _h.map((child) => {
    var _a2;
    let product2 = _products[child == null ? void 0 : child.handle];
    if (!product2) {
      _product.getProductData(child == null ? void 0 : child.handle, child == null ? void 0 : child.product_id).then((prod) => {
        var _a3;
        const index = state.children.findIndex((line) => {
          var _a4;
          return ((_a4 = line.line_item) == null ? void 0 : _a4.key) === (child == null ? void 0 : child.key);
        });
        if (index !== -1) {
          state.children[index] = {
            line_item: child,
            product: prod,
            variant: (_a3 = prod == null ? void 0 : prod.variants) == null ? void 0 : _a3.find((variant3) => variant3.id === (child == null ? void 0 : child.variant_id))
          };
        }
      });
    }
    product2 != null ? product2 : product2 = _products[child == null ? void 0 : child.handle];
    const variant2 = (_a2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _a2.find((variant3) => variant3.id === (child == null ? void 0 : child.variant_id));
    return {
      line_item: child,
      product: product2,
      variant: variant2
    };
  }) : [];
  let product = _products[lineItem == null ? void 0 : lineItem.handle];
  if (!product) {
    _product.getProductData(lineItem == null ? void 0 : lineItem.handle, lineItem == null ? void 0 : lineItem.product_id).then((prod) => {
      var _a2;
      state.product = prod;
      state.variant = (_a2 = prod == null ? void 0 : prod.variants) == null ? void 0 : _a2.find((variant2) => variant2.id === (lineItem == null ? void 0 : lineItem.variant_id));
      state.hydrated = true;
    });
  }
  product != null ? product : product = _products[lineItem == null ? void 0 : lineItem.handle];
  const variant = (_i = product == null ? void 0 : product.variants) == null ? void 0 : _i.find((variant2) => variant2.id === (lineItem == null ? void 0 : lineItem.variant_id));
  const selling_plan = (_m = (_j = lineItem == null ? void 0 : lineItem.selling_plan_allocation) == null ? void 0 : _j.selling_plan) != null ? _m : (_l = (_k = variant == null ? void 0 : variant.selling_plan_allocations) == null ? void 0 : _k[0]) == null ? void 0 : _l.selling_plan;
  const selling_plan_discount_wording = ((_o = (_n = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _n[0]) == null ? void 0 : _o.value) ? ((_q = (_p = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _p[0]) == null ? void 0 : _q.value_type) === "fixed_amount" ? `${utils.formatMoney((_s = (_r = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _r[0]) == null ? void 0 : _s.value)}` : ((_u = (_t = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _t[0]) == null ? void 0 : _u.value_type) === "percentage" ? `${(_w = (_v = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _v[0]) == null ? void 0 : _w.value}%` : "" : "";
  const state = window.Alpine.reactive({
    random_id,
    subscriptionIsChanging: false,
    hydrated: !!variant,
    line_item: lineItem,
    product,
    variant,
    selling_plan_discount_wording,
    url: lineItem == null ? void 0 : lineItem.url,
    children: [...children],
    price: lineItem == null ? void 0 : lineItem.final_price,
    compare_at_price: Math.max(
      (_x = lineItem == null ? void 0 : lineItem.original_price) != null ? _x : 0,
      (_y = variant == null ? void 0 : variant.compare_at_price) != null ? _y : 0,
      (_A = (_z = lineItem == null ? void 0 : lineItem.selling_plan_allocation) == null ? void 0 : _z.compare_at_price) != null ? _A : 0
    ),
    bundle_price: (lineItem == null ? void 0 : lineItem.final_price) + ((children == null ? void 0 : children.reduce(
      (acc, child) => {
        var _a2, _b2;
        return acc += ((_a2 = child == null ? void 0 : child.line_item) == null ? void 0 : _a2.final_price) * (((_b2 = child == null ? void 0 : child.line_item) == null ? void 0 : _b2.quantity) / lineItem.quantity) || 0;
      },
      0
    )) || 0),
    bundle_compare_at_price: Math.max(
      (_B = lineItem == null ? void 0 : lineItem.original_price) != null ? _B : 0,
      (_C = variant == null ? void 0 : variant.compare_at_price) != null ? _C : 0,
      (_E = (_D = lineItem == null ? void 0 : lineItem.selling_plan_allocation) == null ? void 0 : _D.compare_at_price) != null ? _E : 0
    ) + ((children == null ? void 0 : children.reduce(
      (acc, child) => {
        var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
        return acc += Math.max(
          ((_a2 = child == null ? void 0 : child.line_item) == null ? void 0 : _a2.original_price) * (((_b2 = child == null ? void 0 : child.line_item) == null ? void 0 : _b2.quantity) / lineItem.quantity) || 0,
          ((_c2 = child == null ? void 0 : child.variant) == null ? void 0 : _c2.compare_at_price) * (((_d2 = child == null ? void 0 : child.line_item) == null ? void 0 : _d2.quantity) / lineItem.quantity) || 0,
          ((_f2 = (_e2 = child == null ? void 0 : child.line_item) == null ? void 0 : _e2.selling_plan_allocation) == null ? void 0 : _f2.compare_at_price) * (((_g2 = child == null ? void 0 : child.line_item) == null ? void 0 : _g2.quantity) / lineItem.quantity) || 0
        );
      },
      0
    )) || 0),
    quantity_limit: !(children == null ? void 0 : children.length) ? Math.min(
      (variant == null ? void 0 : variant.inventory_management) === "shopify" && (variant == null ? void 0 : variant.inventory_policy) === "deny" ? (variant == null ? void 0 : variant.inventory_quantity) - cart.state.items.reduce(
        (acc, line) => acc += line.variant_id === (variant == null ? void 0 : variant.id) && line.key !== lineItem.key ? line.quantity : 0,
        0
      ) : 9999
    ) : Math.min(
      (variant == null ? void 0 : variant.inventory_management) === "shopify" && (variant == null ? void 0 : variant.inventory_policy) === "deny" ? variant == null ? void 0 : variant.inventory_quantity : 9999,
      ...children.map((child) => {
        var _a2, _b2, _c2;
        const quantity_ratio = child.line_item.quantity / (lineItem == null ? void 0 : lineItem.quantity);
        return ((_a2 = child == null ? void 0 : child.variant) == null ? void 0 : _a2.inventory_management) === "shopify" && ((_b2 = child == null ? void 0 : child.variant) == null ? void 0 : _b2.inventory_policy) === "deny" ? Math.floor(
          (((_c2 = child == null ? void 0 : child.variant) == null ? void 0 : _c2.inventory_quantity) - cart.state.items.reduce(
            (acc, line) => {
              var _a3;
              return acc += line.variant_id === ((_a3 = child == null ? void 0 : child.variant) == null ? void 0 : _a3.id) && line.key !== child.line_item.key ? line.quantity : 0;
            },
            0
          )) / quantity_ratio
        ) : 9999;
      })
    )
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const setSubscription = /* @__PURE__ */ __name(async (selling_plan_id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    state.subscriptionIsChanging = true;
    const p_id = (_b2 = (_a2 = state.line_item) == null ? void 0 : _a2.properties) == null ? void 0 : _b2._p_id;
    const key = (_c2 = state == null ? void 0 : state.line_item) == null ? void 0 : _c2.key;
    const quantity = (_d2 = state == null ? void 0 : state.line_item) == null ? void 0 : _d2.quantity;
    const getUpdateAbleChildren = /* @__PURE__ */ __name(async (id) => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g2;
      const children2 = [];
      for (const child of cart.state.items) {
        if (((_a3 = child == null ? void 0 : child.properties) == null ? void 0 : _a3._p_id_link) !== id) continue;
        let product2 = _products[child == null ? void 0 : child.handle];
        if (!product2) {
          await _product.getProductData(child == null ? void 0 : child.handle, child == null ? void 0 : child.product_id);
        }
        product2 != null ? product2 : product2 = _products[child == null ? void 0 : child.handle];
        const variant2 = (_b3 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _b3.find((variant3) => variant3.id === (child == null ? void 0 : child.variant_id));
        if (!selling_plan_id && ((_d3 = (_c3 = child.selling_plan_allocation) == null ? void 0 : _c3.selling_plan) == null ? void 0 : _d3.id) || ((_e3 = variant2 == null ? void 0 : variant2.selling_plan_allocations) == null ? void 0 : _e3.some((plan) => {
          var _a4;
          return ((_a4 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a4.id) === selling_plan_id;
        })) && ((_g2 = (_f3 = child.selling_plan_allocation) == null ? void 0 : _f3.selling_plan) == null ? void 0 : _g2.id) !== selling_plan_id) {
          children2.push({
            line_item: child,
            product: product2,
            variant: variant2
          });
        }
      }
      return children2;
    }, "getUpdateAbleChildren");
    if (p_id) {
      while ((_e2 = await getUpdateAbleChildren(p_id)) == null ? void 0 : _e2.length) {
        const firstChild = (await getUpdateAbleChildren(p_id))[0];
        await _cart.change({
          id: firstChild.line_item.key,
          selling_plan: +selling_plan_id,
          quantity: firstChild == null ? void 0 : firstChild.line_item.quantity
        });
      }
      const mainItem = (_f2 = cart.state.items) == null ? void 0 : _f2.find((item) => {
        var _a3;
        return ((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id) === p_id;
      });
      await _cart.change({ id: mainItem.key, selling_plan: +selling_plan_id, quantity: mainItem.quantity });
    }
    if (!p_id) {
      await _cart.change({ id: key, selling_plan: +selling_plan_id, quantity });
    }
    state.subscriptionIsChanging = false;
  }, "setSubscription");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    var _a2, _b2;
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a2 = element.closest(`.shopify-section`)) == null ? void 0 : _a2.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        (_b2 = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b2.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  const showConditionally = /* @__PURE__ */ __name((condition) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    switch (condition) {
      case "no_addon_products":
        return !((_a2 = state.children) == null ? void 0 : _a2.length);
      case "addon_products":
        return !!((_b2 = state.children) == null ? void 0 : _b2.length);
      case "always": {
        return true;
      }
      case "with_subscriptions": {
        return !!((_e2 = (_d2 = (_c2 = state.line_item) == null ? void 0 : _c2.selling_plan_allocation) == null ? void 0 : _d2.selling_plan) == null ? void 0 : _e2.id);
      }
      case "no_subscriptions": {
        return !((_h2 = (_g2 = (_f2 = state.line_item) == null ? void 0 : _f2.selling_plan_allocation) == null ? void 0 : _g2.selling_plan) == null ? void 0 : _h2.id);
      }
      case "with_variants": {
        return ((_j2 = (_i2 = state == null ? void 0 : state.product) == null ? void 0 : _i2.variants) == null ? void 0 : _j2.length) > 1;
      }
      case "no_variants": {
        return ((_l2 = (_k2 = state == null ? void 0 : state.product) == null ? void 0 : _k2.variants) == null ? void 0 : _l2.length) <= 1;
      }
    }
  }, "showConditionally");
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    let lineItem2 = Shopify.designMode ? (_c2 = (_b2 = (_a2 = cart.state.items.find((item) => item.key === lineItemKey)) != null ? _a2 : cart.state.items.find((item) => {
      var _a3;
      return !!((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id);
    })) != null ? _b2 : cart.state.items.find((item) => {
      var _a3;
      return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
    })) != null ? _c2 : cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
    if (!lineItem2) {
      for (const item of (_d2 = cart.state.items) != null ? _d2 : []) {
        const components = (_f2 = (_e2 = item.item_components) == null ? void 0 : _e2.map((component) => ({ ...component, item_components: [] }))) != null ? _f2 : [];
        lineItem2 = components.find((component) => component.key === lineItemKey);
        if (lineItem2) break;
      }
    }
    lineItem2 = (_g2 = applyBundleParentDisplay(lineItem2)) != null ? _g2 : state.line_item;
    if (!utils.deepEqual(lineItem2, state.line_item)) {
      state.line_item = lineItem2;
    }
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2;
    const selling_plan2 = (_f2 = (_b2 = (_a2 = state == null ? void 0 : state.line_item) == null ? void 0 : _a2.selling_plan_allocation) == null ? void 0 : _b2.selling_plan) != null ? _f2 : (_e2 = (_d2 = (_c2 = state == null ? void 0 : state.variant) == null ? void 0 : _c2.selling_plan_allocations) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.selling_plan;
    state.selling_plan_discount_wording = ((_h2 = (_g2 = selling_plan2 == null ? void 0 : selling_plan2.price_adjustments) == null ? void 0 : _g2[0]) == null ? void 0 : _h2.value) ? ((_j2 = (_i2 = selling_plan2 == null ? void 0 : selling_plan2.price_adjustments) == null ? void 0 : _i2[0]) == null ? void 0 : _j2.value_type) === "fixed_amount" ? `${utils.formatMoney((_l2 = (_k2 = selling_plan2 == null ? void 0 : selling_plan2.price_adjustments) == null ? void 0 : _k2[0]) == null ? void 0 : _l2.value)}` : ((_n2 = (_m2 = selling_plan2 == null ? void 0 : selling_plan2.price_adjustments) == null ? void 0 : _m2[0]) == null ? void 0 : _n2.value_type) === "percentage" ? `${(_p2 = (_o2 = selling_plan2 == null ? void 0 : selling_plan2.price_adjustments) == null ? void 0 : _o2[0]) == null ? void 0 : _p2.value}%` : "" : "";
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2, _z2, _A2, _B2;
    if (!state.line_item) return;
    state.children = ((_b2 = (_a2 = state == null ? void 0 : state.line_item) == null ? void 0 : _a2.properties) == null ? void 0 : _b2._p_id) ? (_c2 = cart.state.items.filter((child) => {
      var _a3, _b3, _c3;
      return ((_a3 = child == null ? void 0 : child.properties) == null ? void 0 : _a3._p_id_link) === ((_c3 = (_b3 = state == null ? void 0 : state.line_item) == null ? void 0 : _b3.properties) == null ? void 0 : _c3._p_id) && child.quantity;
    })) == null ? void 0 : _c2.map((child) => {
      var _a3;
      let product2 = _products[child == null ? void 0 : child.handle];
      if (!product2) {
        _product.getProductData(child == null ? void 0 : child.handle, child == null ? void 0 : child.product_id).then((prod) => {
          var _a4;
          const index = state.children.findIndex((line) => {
            var _a5;
            return ((_a5 = line.line_item) == null ? void 0 : _a5.key) === (child == null ? void 0 : child.key);
          });
          if (index !== -1) {
            state.children[index] = {
              line_item: child,
              product: prod,
              variant: (_a4 = prod == null ? void 0 : prod.variants) == null ? void 0 : _a4.find((variant3) => variant3.id === (child == null ? void 0 : child.variant_id))
            };
          }
        });
      }
      product2 != null ? product2 : product2 = _products[child == null ? void 0 : child.handle];
      const variant2 = (_a3 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _a3.find((variant3) => variant3.id === (child == null ? void 0 : child.variant_id));
      return {
        line_item: child,
        product: product2,
        variant: variant2
      };
    }) : [];
    state.price = (_d2 = state.line_item) == null ? void 0 : _d2.final_price;
    state.compare_at_price = Math.max(
      (_f2 = (_e2 = state.line_item) == null ? void 0 : _e2.original_price) != null ? _f2 : 0,
      (_h2 = (_g2 = state.variant) == null ? void 0 : _g2.compare_at_price) != null ? _h2 : 0,
      (_k2 = (_j2 = (_i2 = state.line_item) == null ? void 0 : _i2.selling_plan_allocation) == null ? void 0 : _j2.compare_at_price) != null ? _k2 : 0
    );
    state.bundle_price = ((_l2 = state.line_item) == null ? void 0 : _l2.final_price) + (((_m2 = state.children) == null ? void 0 : _m2.reduce(
      (acc, child) => {
        var _a3, _b3;
        return acc += ((_a3 = child == null ? void 0 : child.line_item) == null ? void 0 : _a3.final_price) * (((_b3 = child == null ? void 0 : child.line_item) == null ? void 0 : _b3.quantity) / state.line_item.quantity) || 0;
      },
      0
    )) || 0);
    state.bundle_compare_at_price = Math.max(
      (_o2 = (_n2 = state.line_item) == null ? void 0 : _n2.original_price) != null ? _o2 : 0,
      (_q2 = (_p2 = state.variant) == null ? void 0 : _p2.compare_at_price) != null ? _q2 : 0,
      (_t2 = (_s2 = (_r2 = state.line_item) == null ? void 0 : _r2.selling_plan_allocation) == null ? void 0 : _s2.compare_at_price) != null ? _t2 : 0
    ) + (((_u2 = state.children) == null ? void 0 : _u2.reduce(
      (acc, child) => {
        var _a3, _b3, _c3, _d3, _e3, _f3, _g3;
        return acc += Math.max(
          ((_a3 = child == null ? void 0 : child.line_item) == null ? void 0 : _a3.original_price) * (((_b3 = child == null ? void 0 : child.line_item) == null ? void 0 : _b3.quantity) / state.line_item.quantity) || 0,
          ((_c3 = child == null ? void 0 : child.variant) == null ? void 0 : _c3.compare_at_price) * (((_d3 = child == null ? void 0 : child.line_item) == null ? void 0 : _d3.quantity) / state.line_item.quantity) || 0,
          ((_f3 = (_e3 = child == null ? void 0 : child.line_item) == null ? void 0 : _e3.selling_plan_allocation) == null ? void 0 : _f3.compare_at_price) * (((_g3 = child == null ? void 0 : child.line_item) == null ? void 0 : _g3.quantity) / state.line_item.quantity) || 0
        );
      },
      0
    )) || 0);
    state.quantity_limit = !((_v2 = state.children) == null ? void 0 : _v2.length) ? Math.min(
      ((_w2 = state.variant) == null ? void 0 : _w2.inventory_management) === "shopify" && ((_x2 = state.variant) == null ? void 0 : _x2.inventory_policy) === "deny" ? ((_y2 = state.variant) == null ? void 0 : _y2.inventory_quantity) - cart.state.items.reduce(
        (acc, line) => {
          var _a3, _b3;
          return acc += line.variant_id === ((_a3 = state.variant) == null ? void 0 : _a3.id) && line.key !== ((_b3 = state == null ? void 0 : state.line_item) == null ? void 0 : _b3.key) ? line.quantity : 0;
        },
        0
      ) : 9999
    ) : Math.min(
      ((_z2 = state.variant) == null ? void 0 : _z2.inventory_management) === "shopify" && ((_A2 = state.variant) == null ? void 0 : _A2.inventory_policy) === "deny" ? (_B2 = state.variant) == null ? void 0 : _B2.inventory_quantity : 9999,
      ...state.children.map((child) => {
        var _a3, _b3, _c3, _d3;
        const quantity_ratio = child.line_item.quantity / ((_a3 = state.line_item) == null ? void 0 : _a3.quantity);
        return ((_b3 = child == null ? void 0 : child.variant) == null ? void 0 : _b3.inventory_management) === "shopify" && ((_c3 = child == null ? void 0 : child.variant) == null ? void 0 : _c3.inventory_policy) === "deny" ? Math.floor(
          (((_d3 = child == null ? void 0 : child.variant) == null ? void 0 : _d3.inventory_quantity) - cart.state.items.reduce(
            (acc, line) => {
              var _a4;
              return acc += line.variant_id === ((_a4 = child == null ? void 0 : child.variant) == null ? void 0 : _a4.id) && line.key !== child.line_item.key ? line.quantity : 0;
            },
            0
          )) / quantity_ratio
        ) : 9999;
      })
    );
  });
  return {
    line_card: state,
    $el,
    showConditionally,
    setSubscription,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
    hideIfEmpty
  };
}, "initLineItemCard");
const hydrateLineItemCard = /* @__PURE__ */ __name(($el, card_handle, line_item_key, classes = []) => {
  var _a;
  const node = (_a = document.querySelector(`[data-line-item-card='${card_handle}']`)) == null ? void 0 : _a.cloneNode(true);
  if (!node) {
    $el.setAttribute("data-intersected", "true");
    const mo = new MutationObserver((mutation, obs) => {
      var _a2;
      if ($el.hasAttribute("data-cards-loaded")) {
        $el.removeAttribute("data-intersected");
        const node2 = (_a2 = document.querySelector(`[data-line-item-card='${card_handle}']`)) == null ? void 0 : _a2.cloneNode(true);
        if (node2 && $el && $el.parentNode) {
          node2 == null ? void 0 : node2.removeAttribute(`data-line-item-card`);
          node2 == null ? void 0 : node2.setAttribute("data-line-item-key", line_item_key);
          node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
            el.remove();
          });
          node2.classList.add(...classes);
          $el.parentNode.replaceChild(node2, $el);
        }
        mo.disconnect();
      }
    });
    mo.observe($el, { attributes: true });
    return;
  }
  if (node && $el && $el.parentNode) {
    node == null ? void 0 : node.removeAttribute(`data-line-item-card`);
    node == null ? void 0 : node.setAttribute("data-line-item-key", line_item_key);
    node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
      el.remove();
    });
    node.classList.add(...classes);
    $el.parentNode.replaceChild(node, $el);
  }
}, "hydrateLineItemCard");
window._sections["initLineItemCard"] = initLineItemCard;
window._sections["hydrateLineItemCard"] = hydrateLineItemCard;
